import React from 'react'
import { Avatar } from 'primereact/avatar';

const Messages = ({ senderType,senderImage, senderName,sentTime,status,message, }) => {
    

    const renderStatusIcon = () => {
        if (status === 'sent') {
          return <i className="pi pi-check text-gray-400"></i>;
        } else if (status === 'delivered') {
          return (
            <>
              <i className="pi pi-check text-gray-400"></i>
              <i className="pi pi-check text-gray-400 ml-1"></i>
            </>
          );
        } else if (status === 'read') {
          return (
            <>
              <i className="pi pi-check text-green-400"></i>
              <i className="pi pi-check text-green-400 ml-1"></i>
            </>
          );
        }
        return null;
      };
    
    return (
      <div>
        {senderType === 'sender' ? (
          <div>
            <div className="grid grid-nogutter mb-4">
              <div className="col mt-3 text-right">
                <span className="inline-block text-left font-medium border-1 surface-border bg-primary-100 text-primary-900 p-3 white-space-normal border-round" style={{ wordBreak: 'break-word', maxWidth: '80%' }}>{message}</span>
                <p className="text-700 mt-3">{sentTime} {renderStatusIcon()}</p>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="grid grid-nogutter mb-4">
              <Avatar className="p-overlay-badge" shape="circle" image={senderImage} size="large">
                </Avatar>
              <div className="col mt-0 ml-2">
                <p className="text-900 font-semibold mb-3">{senderName}</p>
                <span className="text-700 inline-block font-medium border-1 surface-border p-3 white-space-normal border-round" style={{ wordBreak: 'break-word', maxWidth: '80%' }}>
                    {message}</span>
                <p className="text-700 mt-3">{sentTime}{renderStatusIcon()}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
  
  export default Messages;
